<template>
    <div>
      <SubTitle text="Mapa de sectores"/>
      <div class="card-section">
        <HeatMap :points="points"/>
      </div>
    </div>
</template>

<script>
import SubTitle from '../../base/SubTitle.vue';
import HeatMap from '../../maps/HeatMap.vue';

export default {
  props: {
    points: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: 'SectorMap',
  components: {
    SubTitle,
    HeatMap,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  .card-section {
    height: 281px;
    background-color: transparent;
    box-shadow: inset 0 0 20px 0 rgba(0, 0, 0, 0.05);
  }
</style>
